import { hcl, rgb } from 'd3-color';
import { interpolateHcl } from 'd3-interpolate';
import { findEdge } from "../math";
export var interpolate = function interpolate(a, b) {
  return interpolateHcl(a, b);
};
export var toRgb = function toRgb(str) {
  return rgb(str);
};
export var toHex = function toHex(str) {
  return rgb(str).hex();
};
export var toHcl = function toHcl(str) {
  return hcl(str);
};
export var setOpacity = function setOpacity(str, opacity) {
  var color = toRgb(str);
  color.opacity = opacity;
  return color;
};
export var isColorDisplayable = function isColorDisplayable(str) {
  return rgb(str).displayable();
}; // Reduces a color’s chroma until it is displayable and satisfies an optional
// condition.

export var clipChroma = function clipChroma(str, predicate) {
  var color = hcl(str);
  var chroma = findEdge(color.c, 0, function (c) {
    color.c = c;
    return color.displayable() && (!predicate || predicate(color));
  }, 1);
  color.c = chroma;
  return color;
}; // Used to transform a translucent color into an opaque color.
// Returns the resulting color when a foreground color is displayed atop
// the background color.

export var compositeAlpha = function compositeAlpha(foreground) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'white';
  var fg = toRgb(foreground);

  if (fg.opacity === 1) {
    return fg;
  }

  var bg = toRgb(background); // If the background is translucent, composite it over white.

  if (bg.opacity !== 1) {
    bg = compositeAlpha(bg);
  }

  if (fg.opacity === 0) {
    return bg;
  } // https://en.wikipedia.org/wiki/Alpha_compositing


  var opacity = fg.opacity;
  var r = opacity * fg.r + (1 - opacity) * bg.r;
  var g = opacity * fg.g + (1 - opacity) * bg.g;
  var b = opacity * fg.b + (1 - opacity) * bg.b;
  return rgb(r, g, b);
}; // Used to transform a opaque color into a translucent color.
// Returns a foreground color with the provided opacity that matches the
// provided composite color when displayed atop the background color.
//
// NOTE: This could result in an imaginary color.

export var decompositeAlpha = function decompositeAlpha(opacity, composite) {
  var background = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'white';
  var comp = toRgb(composite);

  if (opacity === 1) {
    return comp;
  }

  var bg = toRgb(background); // If the background is translucent, composite it over white.

  if (bg.opacity !== 1) {
    bg = compositeAlpha(bg);
  }

  if (opacity === 0) {
    return bg;
  } // https://en.wikipedia.org/wiki/Alpha_compositing
  // Solve for the foreground channel:


  var r = (comp.r - (1 - opacity) * bg.r) / opacity;
  var g = (comp.g - (1 - opacity) * bg.g) / opacity;
  var b = (comp.b - (1 - opacity) * bg.b) / opacity;
  return rgb(r, g, b, opacity);
};